export default "__VITE_ASSET__e782473a__"